import { render, staticRenderFns } from "./serviceHall.vue?vue&type=template&id=b20339d4&scoped=true&"
import script from "./serviceHall.vue?vue&type=script&lang=js&"
export * from "./serviceHall.vue?vue&type=script&lang=js&"
import style0 from "./serviceHall.vue?vue&type=style&index=0&id=b20339d4&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b20339d4",
  null
  
)

export default component.exports